import baseApi from "./baseApi.js";
import axios from '@/models/API/axios'
import * as apiUrl from './apiUrl.js';

/**
 * 契約api
 */
class contractApi extends baseApi {
    constructor() {
        super();
        this.baseApi = new baseApi();
    }

    /**
     * 查詢契約
     * @param {Object.<string, string>} callback
     * @param {Object.<string, string>} params 查詢參數
     * @param {Boolean} is_loading 是否有讀取轉圈動畫
     */
    getMember(callback = {}, params = {}, is_loading = true) {
        const options = {
            method: this.request.method.get,
            url: `${apiUrl.API_GET_MEMBER}`,
            params: params,
            is_loading: is_loading,
            headers: { 'Content-Type': this.request.headers.contentType.appJsonUtf8 }
        };
        axios(options).then((response) => {
            callback(response);
        }).catch((err) => {
            callback(err.response);
        });
    }

    /**
     * 新增契約
     * @param {Object.<string, string>} callback
     * @param {Object.<string, string>} params 新增參數
     */
    addMember(callback = {}, params = {}) {
        const options = {
            method: this.request.method.post,
            url: `${apiUrl.API_POST_MEMBER}`,
            data: params,
            is_loading: true,
            headers: { 'Content-Type': this.request.headers.contentType.appJsonUtf8 }
        };
        axios(options).then((response) => {
            callback(response);
        }).catch((err) => {
            callback(err.response);
        });
    }

    /**
     * 更新契約
     * @param {Object.<string, string>} callback
     * @param {Object.<string, string>} params 更新參數
     */
    updateMember(callback = {}, params = {}) {
        const options = {
            method: this.request.method.put,
            url: `${apiUrl.API_PUT_MEMBER}/${params.id}`,
            data: params,
            is_loading: true,
            headers: { 'Content-Type': this.request.headers.contentType.appJsonUtf8 }
        };
        axios(options).then((response) => {
            callback(response);
        }).catch((err) => {
            callback(err.response);
        });
    }

    /**
     * 刪除契約
     * @param {Object.<string, string>} callback
     * @param {Object.<string, string>} id 刪除參數
     */
    deleteMember(callback = {}, id = {}) {
        const options = {
            method: this.request.method.delete,
            url: `${apiUrl.API_PUT_MEMBER}/${id}`,
            is_loading: true,
            headers: { 'Content-Type': this.request.headers.contentType.appJsonUtf8 }
        };
        axios(options).then((response) => {
            callback(response);
        }).catch((err) => {
            callback(err.response);
        });
    }

    /**
     * 更新契約狀態
     * @param {Object.<string, string>} callback
     * @param {Object.<string, string>} params 更新參數
     */
    updateStatus(callback = {}, params = {}) {
        const options = {
            method: this.request.method.post,
            url: apiUrl.API_UPDATE_STATUS,
            data: params,
            is_loading: true,
            headers: { 'Content-Type': this.request.headers.contentType.appJsonUtf8 }
        };
        axios(options).then((response) => {
            callback(response);
        }).catch((err) => {
            callback(err.response);
        });
    }

    /**
     * 查詢契約促銷設定
     * @param {Object.<string, string>} callback
     * @param {Object.<string, string>} params 查詢參數
     */
    getPromotion(callback = {}, params = {}) {
        const options = {
            method: this.request.method.get,
            url: `${apiUrl.API_GET_PROMOTION}`,
            params: params,
            is_loading: true,
            headers: { 'Content-Type': this.request.headers.contentType.appJsonUtf8 }
        };
        axios(options).then((response) => {
            callback(response);
        }).catch((err) => {
            callback(err.response);
        });
    }

    /**
     * 新增契約促銷設定
     * @param {Object.<string, string>} callback
     * @param {Object.<string, string>} params 新增參數
     */
    addPromotion(callback = {}, params = {}) {
        const options = {
            method: this.request.method.post,
            url: `${apiUrl.API_POST_PROMOTION}`,
            data: params,
            is_loading: true,
            headers: { 'Content-Type': this.request.headers.contentType.appJsonUtf8 }
        };
        axios(options).then((response) => {
            callback(response);
        }).catch((err) => {
            callback(err.response);
        });
    }

    /**
     * 更新契約促銷設定
     * @param {Object.<string, string>} callback
     * @param {Object.<string, string>} params 更新參數
     */
    updatePromotion(callback = {}, params = {}) {
        const options = {
            method: this.request.method.put,
            url: `${apiUrl.API_PUT_PROMOTION}/${params.id}`,
            data: params,
            is_loading: true,
            headers: { 'Content-Type': this.request.headers.contentType.appJsonUtf8 }
        };
        axios(options).then((response) => {
            callback(response);
        }).catch((err) => {
            callback(err.response);
        });
    }

    /**
     * 刪除契約促銷設定
     * @param {Object.<string, string>} callback
     * @param {Object.<string, string>} id 刪除參數
     */
    deletePromotion(callback = {}, id = {}) {
        const options = {
            method: this.request.method.delete,
            url: `${apiUrl.API_PUT_PROMOTION}/${id}`,
            is_loading: true,
            headers: { 'Content-Type': this.request.headers.contentType.appJsonUtf8 }
        };
        axios(options).then((response) => {
            callback(response);
        }).catch((err) => {
            callback(err.response);
        });
    }

    /**
     * 查詢互助
     * @param {Object.<string, string>} callback
     * @param {Object.<string, string>} params 查詢參數
     * @param {Boolean} is_loading 是否有讀取轉圈動畫
     */
    getHelp(callback = {}, params = {}, is_loading = true) {
        const options = {
            method: this.request.method.get,
            url: `${apiUrl.API_GET_HELP}`,
            params: params,
            is_loading: is_loading,
            headers: { 'Content-Type': this.request.headers.contentType.appJsonUtf8 }
        };
        axios(options).then((response) => {
            callback(response);
        }).catch((err) => {
            callback(err.response);
        });
    }

    /**
     * 查詢互助身故名單
     * @param {Object.<string, string>} callback
     * @param {Object.<string, string>} params 查詢參數
     * @param {Boolean} is_loading 是否有讀取轉圈動畫
     */
      getDeadList(callback = {}, params = {}, is_loading = true) {
        const options = {
            method: this.request.method.get,
            url: `${apiUrl.API_GET_DEAD_LIST}`,
            params: params,
            is_loading: is_loading,
            headers: { 'Content-Type': this.request.headers.contentType.appJsonUtf8 }
        };
        axios(options).then((response) => {
            callback(response);
        }).catch((err) => {
            callback(err.response);
        });
      }

    /**
     * 查詢遞延
     * @param {Object.<string, string>} callback
     * @param {Object.<string, string>} params 查詢參數
     * @param {Boolean} is_loading 是否有讀取轉圈動畫
     */
    getDeferred(callback = {}, params = {}, is_loading = true) {
        const options = {
            method: this.request.method.get,
            url: `${apiUrl.API_GET_DEFERRED}`,
            params: params,
            is_loading: is_loading,
            headers: { 'Content-Type': this.request.headers.contentType.appJsonUtf8 }
        };
        axios(options).then((response) => {
            callback(response);
        }).catch((err) => {
            callback(err.response);
        });
    }

    /**
     * 匯出契約EXCEL
     * @param {Object.<string, string>} callback
     * @param {Object.<string, string>} params 查詢參數
     */
    exportMember(callback = {}, params = {}) {
        const options = {
            method: this.request.method.get,
            url: `${apiUrl.API_GET_EXPORT_MEMBER}`,
            params: params,
            is_loading: true,
            responseType: "blob",
            headers: { 'Content-Type': this.request.headers.contentType.appJsonUtf8 }
        };
        axios(options).then((response) => {
            callback(response);
        }).catch((err) => {
            callback(err.response);
        });
    }

    /**
     * 匯出分紅制度報表EXCEL
     * @param {Object.<string, string>} callback
     * @param {Object.<string, string>} params 查詢參數
     */
    exportDividendReport(callback = {}, params = {}) {
        const options = {
            method: this.request.method.get,
            url: `${apiUrl.API_GET_EXPORT_REPORT_DIVIDEND}`,
            params: params,
            is_loading: true,
            responseType: "blob",
            headers: { 'Content-Type': this.request.headers.contentType.appJsonUtf8 }
        };
        axios(options).then((response) => {
            callback(response);
        }).catch((err) => {
            callback(err.response);
        });
    }

    /**
     * 查詢契約LOG
     * @param {Object.<string, string>} callback
     * @param {Object.<string, string>} params 查詢參數
     */
    getMembersLogs(callback = {}, params = {}) {
      const options = {
          method: this.request.method.get,
          url: `${apiUrl.API_GET_MEMBERS_LOGS}`,
          params: params,
          is_loading: true,
          headers: { 'Content-Type': this.request.headers.contentType.appJsonUtf8 }
      };
      axios(options).then((response) => {
          callback(response);
      }).catch((err) => {
          callback(err.response);
      });
    }

    /**
     * 重設理賠
     * @param {Object.<string, string>} callback
     * @param {Object.<string, string>} params 重設參數
     */
    claimMember(callback = {}, params = {}) {
      const options = {
          method: this.request.method.post,
          url: `${apiUrl.API_POST_CLAIM_MEMBERS}`,
          data: params,
          is_loading: true,
          headers: { 'Content-Type': this.request.headers.contentType.appJsonUtf8 }
      };
      axios(options).then((response) => {
          callback(response);
      }).catch((err) => {
          callback(err.response);
      });
    }

    /**
     * 上傳身故證明圖片
     * @param {Object.<string, string>} callback
     * @param {FromData} data 上傳檔案
     * @return {Object}
     */
    uploadClaimImage(callback = {}, data = new FormData()) {
      const options = {
          method: this.request.method.post,
          url: apiUrl.API_POST_UPLOAD_CLAIM_IMAGE,
          data: data,
          is_loading: true,
          headers: { 'Content-Type': this.request.headers.contentType.multipartFormData }
      };
      axios(options).then((response) => {
          callback(response);
      }).catch((err) => {
          callback(err.response);
      });
    }

    /**
     * 查詢顯示於前台契約
     * @param {Object.<string, string>} callback
     * @param {Object.<string, string>} params 查詢參數
     * @param {Boolean} is_loading 是否有讀取轉圈動畫
     */
    getDisplayMember(callback = {}, params = {}, is_loading = true) {
      const options = {
          method: this.request.method.post,
          url: `${apiUrl.API_GET_DISPLAY_MEMBER}`,
          params: params,
          is_loading: is_loading,
          headers: { 'Content-Type': this.request.headers.contentType.appJsonUtf8 }
      };
      axios(options).then((response) => {
          callback(response);
      }).catch((err) => {
          callback(err.response);
      });
    }

    /**
     * 查詢設定自動扣款資料
     * @param {Object.<string, string>} callback
     * @param {Object.<string, string>} params 查詢參數
     * @param {Boolean} is_loading 是否有讀取轉圈動畫
     */
    getSetAutoApply(callback = {}, params = {}, is_loading = true) {
      const options = {
          method: this.request.method.get,
          url: `${apiUrl.API_GET_SET_AUTO_APPLY}`,
          params: params,
          is_loading: is_loading,
          headers: { 'Content-Type': this.request.headers.contentType.appJsonUtf8 }
      };
      axios(options).then((response) => {
          callback(response);
      }).catch((err) => {
          callback(err.response);
      });
    }

    /**
     * 查詢預領
     * @param {Object.<string, string>} callback
     * @param {Object.<string, string>} params 查詢參數
     * @param {Boolean} is_loading 是否有讀取轉圈動畫
     */
    getLoan(callback = {}, params = {}, is_loading = true) {
      const options = {
          method: this.request.method.get,
          url: `${apiUrl.API_GET_Loan}`,
          params: params,
          is_loading: is_loading,
          headers: { 'Content-Type': this.request.headers.contentType.appJsonUtf8 }
      };
      axios(options).then((response) => {
          callback(response);
      }).catch((err) => {
          callback(err.response);
      });
    }

    /**
     * 新增預領
     * @param {Object.<string, string>} callback
     * @param {Object.<string, string>} params 新增參數
     * @param {Boolean} is_loading 是否有讀取轉圈動畫
     */
    addLoan(callback = {}, params = {}, is_loading = true) {
        const options = {
            method: this.request.method.post,
            url: `${apiUrl.API_POST_Loan}`,
            data: params,
            is_loading: is_loading,
            headers: { 'Content-Type': this.request.headers.contentType.appJsonUtf8 }
        };
        axios(options).then((response) => {
            callback(response);
        }).catch((err) => {
            callback(err.response);
        });
    }

    /**
     * 更新預領
     * @param {Object.<string, string>} callback
     * @param {Object.<string, string>} params 更新參數
     * @param {Boolean} is_loading 是否有讀取轉圈動畫
     */
    updateLoan(callback = {}, params = {}, is_loading = true) {
        const options = {
            method: this.request.method.put,
            url: `${apiUrl.API_PUT_Loan}/${params.id}`,
            data: params,
            is_loading: is_loading,
            headers: { 'Content-Type': this.request.headers.contentType.appJsonUtf8 }
        };
        axios(options).then((response) => {
            callback(response);
        }).catch((err) => {
            callback(err.response);
        });
    }

    /**
     * 刪除預領
     * @param {Object.<string, string>} callback
     * @param {Object.<string, string>} id 刪除參數
     * @param {Boolean} is_loading 是否有讀取轉圈動畫
     */
    deleteLoan(callback = {}, id = {}, is_loading = true) {
        const options = {
            method: this.request.method.delete,
            url: `${apiUrl.API_DELETE_Loan}/${id}`,
            is_loading: is_loading,
            headers: { 'Content-Type': this.request.headers.contentType.appJsonUtf8 }
        };
        axios(options).then((response) => {
            callback(response);
        }).catch((err) => {
            callback(err.response);
        });
    }
}

export default contractApi;



// WEBPACK FOOTER //
// ./src/models/API/contractApi.js